<template>
	<div class="ticks" :style="styleProp">
		<div class="tick" v-for="marker in Markers" :key="marker.x" :style="{left: marker.x + '%'}">
		</div>
		<div class="day tick" :style="{left: DayTick.x + '%'}">
		</div>
		<div class="day tick shift" v-if="ShiftDate" :style="{left: ShiftDayTick.x + '%'}">
		</div>
	</div>
</template>

<script>

	import timeStore from '../repositories/TimeManager';

	const RulerTicks = {
		//data: function () {
		//	return {
		//	//	MarkerDate: new Date()
		//	}
		//},
		props: {
			
			MarkerDate: { type: Date },
			ShiftDate: { type: Date },
			Markers: { type : Array },
			styleProp: { type : Object }
		},

		methods: {

		},

		computed: {

			DayTick: function () {
				let x = timeStore.calculateXPosition(this.MarkerDate);					
				return { x: x };
			},

			ShiftDayTick: function () {
				if (this.ShiftDate) {
					let x = timeStore.calculateXPosition(this.ShiftDate);
					return { x: x };
				}
				return 0;
			}
		}
	};

	export { RulerTicks as default };

</script>
